import {Injectable} from "@angular/core";
import {HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {finalize} from "rxjs";
import {LoaderService} from "../services";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor{
  private totalRequests = 0;

  constructor(private loaderService: LoaderService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.url.includes('api/document/download') || request.responseType !== 'blob') {
      this.totalRequests++;
      this.loaderService.setLoading(true);
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (request.url.includes('api/document/download') || request.responseType !== 'blob') {
          this.totalRequests--;
          if (this.totalRequests === 0) {
            this.loaderService.setLoading(false);
          }
        }
      })
    );
  }
}
